import TbSysTitleEntity from "./TbSysTitleEntity";

/**
 * 시스템 - 타이틀
 */
export default class TbSysTitle extends TbSysTitleEntity {}
